export default {
  setInfo: (state, value) => { state.userInfo = value }
}
